import { createContext, useContext, type FormEvent, type MutableRefObject } from 'react'

type FgtsLoanSimulatorContextProps = {
  onToggleIncomeType: () => void
  handleOnSubmit: (event: FormEvent) => void
  birthDateRef: MutableRefObject<HTMLInputElement | null>
  availableAmountRef: MutableRefObject<HTMLInputElement | null>
  salaryRef: MutableRefObject<HTMLInputElement | null>
  monthsWorkedRef: MutableRefObject<HTMLInputElement | null>
  ctaHref: string
  backStep: () => void
  amountReceivable: string
  hasFgts: boolean
}

export const FgtsLoanSimulatorContext = createContext({} as FgtsLoanSimulatorContextProps)

export const useFgtsLoanSimulator = () => useContext(FgtsLoanSimulatorContext)
